<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      :pageTitle="$t('menu.standardNode')"
    >
      <BasiceLayout :title="$t('watch')">
        <span class="margin-left-20">主机名：</span>
        <el-select
          v-model="newServerBcode"
          placeholder=""
          @change="search"
        >
          <el-option
            v-for="item in hostNameOptions"
            v-if="item.serverHostname"
            :key="item.serverBcode"
            :label="item.serverHostname"
            :value="item.serverBcode"
          >
          </el-option>
        </el-select>
        <span class="margin-left-20">查询条件：</span>
        <el-select
          v-model="selectQueryType"
          @change="search"
          clearable
        >
          <el-option
            v-for="item in queryOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span class="margin-left-20">日期：</span>
        <el-date-picker
          v-model="selectDate"
          type="date"
          placeholder="选择日期"
          :picker-options="pickerOptions"
          @change="search"
          clearable
          style="margin: 20px; box-sizing: border-box;display: inline-block;"
        >
        </el-date-picker>
        <div v-loading="isLoading" style="width: 100%; min-height: 100px;">
          <div class="standard-node-watch">
            <ve-line
              v-if="flowResult &&  flowResult.rows && flowResult.rows.length"
              class="watch-chart"
              :data="flowResult"
            ></ve-line>
            <ve-line
              v-if="cpuResult && cpuResult.rows && cpuResult.rows.length"
              class="watch-chart"
              :data="cpuResult"
              :settings="percentSetting"
            ></ve-line>
            <ve-line
              v-if="memResult && memResult .rows && memResult.rows.length"
              :data="memResult"
              :settings="percentSetting"
              class="watch-chart"
            ></ve-line>
            <!-- <ve-line
              v-if="memUsedResult && memUsedResult .rows && memUsedResult.rows.length"
              class="watch-chart"
              :data="memUsedResult"
            ></ve-line> -->
            <!-- 磁盘空间利用率 -->
            <!-- <ve-line
              v-if="diskResult && diskResult .rows && diskResult.rows.length"
              class="watch-chart"
              :data="diskResult"
            ></ve-line>
            <ve-line
              v-if="diskioResult && diskioResult .rows && diskioResult.rows.length"
              class="watch-chart"
              :setting="diskioSetting"
              :data="diskioResult"
            ></ve-line> -->
          </div>
          <!-- 磁盘使用 -->
          <div class="watch-real-data margin-20" v-if="memUsedResult.length">
            <!-- this.diskioResult = diskioResult; -->
            <!-- this.diskResult = diskResult; -->
            <el-table
              :data="memUsedResult"
              style="width: 100%"
            >
              <el-table-column
                prop="title"
                label="磁盘使用"
                align='center'
              >
              </el-table-column>
              <el-table-column
                prop="time"
                label="更新时间"
                align='center'
              >
              </el-table-column>
              <!-- 磁盘使用 -->
              <el-table-column
                label="磁盘使用（GB）"
                align='center'
              >
                <template slot-scope="scope">
                  <div :class="{ 'bonus-tips': !scope.row.used}">{{scope.row.used}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 磁盘空间利用率 -->
          <div class="watch-real-data margin-20" v-if="diskResult && diskResult.length">
            <el-table
              :data="diskResult"
              style="width: 100%"
            >
              <el-table-column
                prop="title"
                label="磁盘空间利用率（百分比）"
                align='center'
              >
              </el-table-column>
              <el-table-column
                prop="time"
                label="更新时间"
                align='center'
              >
              </el-table-column>
              <!-- 磁盘空间利用率 -->
              <el-table-column
                label="磁盘空间利用率（百分比）"
                align='center'
              >
                <template slot-scope="scope">
                  <div :class="{ 'bonus-tips': !scope.row.used_percent}">{{scope.row.used_percent}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 节点磁盘IO -->
          <div class="watch-real-data margin-20" v-if="diskioResult && diskioResult.length">
            <!-- this.diskioResult = diskioResult; -->
            <!-- this.diskResult = diskResult; -->
            <el-table
              :data="diskioResult"
              style="width: 100%"
            >
              <el-table-column
                prop="title"
                label="磁盘节点磁盘IO"
                align='center'
              >
              </el-table-column>
              <el-table-column
                prop="time"
                label="更新时间"
                align='center'
              >
              </el-table-column>
              <!-- 磁盘百分比 -->
              <el-table-column
                label="节点磁盘IO（百分比）"
                align='center'
              >
                <template slot-scope="scope">
                  <div :class="{ 'bonus-tips': !scope.row.io_util}">{{scope.row.io_util}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>
<i18n>
{
  "en": {
    "flowText": "单节点带宽（Mbps）",
    "cpuText": "CPU使用率（百分比）",
    "memText": "内存使用率（百分比）",
    "diskIoText": "节点磁盘IO"
  }
}
</i18n>
<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG } from "../../../config/contant.js";
import Layout from "@/components/DatePanel/Layout.vue";
import { BytesToM, toFixed, BytesToG } from "@/utils/utils";

export default {
  name: "home",
  components: {
    BasiceLayout,
    Layout
  },
  data() {
    return {
      newServerBcode: "",
      selectDate: "",
      useBandCharts: {},
      cpuResult: [],
      memResult: [],
      diskResult: [],
      memUsedResult: [], //磁盘使用
      flowResult: [],
      diskioResult: [],
      percentSetting: {
        yAxisType: ["percent"],
        yAxisName: ["百分比"]
      },
      diskioSetting: {
        yAxisType: ["percent"],
        yAxisName: ["百分比"]
      },
      pickerOptions:
      this.limitDate(),
      // {
      //   disabledDate: time => {
      //     // 一个月
      //     return (
      //       time.getTime() <
      //         moment()
      //           .startOf("day")
      //           .valueOf() -
      //            24 * 1000 * 60 * 60 * 30 || time.getTime() > moment().valueOf()
      //     );
      //   }
      // }
      hostNameOptions: [],
      isLoading: false,
      queryOptions: [
        {id:1, label:'单节点带宽'},
        {id:2, label:'CPU使用率'},
        {id:3, label:'内存使用率'},
        {id:4, label:'磁盘已用空间和利用率'},
        {id:5, label:'磁盘IO'},
      ],
      selectQueryType:'',
    };
  },
  computed: mapState({
    nodeConfig: state => state.standardNode.nodeConfig,
    serverBcode() {
      if (
        this.nodeConfig &&
        this.nodeConfig.length &&
        this.nodeConfig !== "NODATA"
      ) {
        let serverHostname;
        this.nodeConfig.find(item => {
          serverHostname = item.serverHostname;
          return item.serverHostname;
        });
        return serverHostname;
      }
    }
  }),
  methods: {
    ...mapActions(["getStandardNode", "getNodeInfByBcode","getStandardNodeHostNameAndBcode"]),
    limitDate(){
        var curTime = new Date();
        var curYear = curTime .getFullYear();
        var curMonth = curTime .getMonth();
        var curMonthFirstDay = new Date(curYear,curMonth,1);
        var beforeMonth = curMonth-1;

        if(beforeMonth==-1){
          curYear = curYear-1;
          beforeMonth = 11;
        }

        var beforeStartDate = new Date(curYear,beforeMonth,1);

        return {
          disabledDate(time){
            return time.getTime() < moment(beforeStartDate).valueOf()|| time.getTime() > moment().valueOf();
          }
        }
      },
    dealFlow(data) {
      if (!data.length) {
        return;
      }

      let watchDate = this.$t("watchDetail.watchDate");
      let watchUseBand = this.$t("flowText");
      // 此处为了中英文对照，所以动态处理
      let useBandCharts = {
        columns: [],
        rows: []
      };

      useBandCharts.columns = [watchDate, watchUseBand];

      data.map(item => {
        let { time, in_bps, out_bps } = item;
        // let value = isDcache ? diffBps : out_bps;
        let value = out_bps;
        let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");

        let useBandRows = [];
        // 日期处理
        useBandRows[watchDate] = date_at;
        useBandRows[watchUseBand] = toFixed(BytesToM(value));

        useBandCharts.rows.push(useBandRows);
      });

      this.flowResult = useBandCharts;
    },
    dealCpu(data) {
      if (!data.length) {
        return;
      }
      let watchDate = this.$t("watchDetail.watchDate");
      let watchUseBand = this.$t("cpuText");
      // 此处为了中英文对照，所以动态处理
      let useBandCharts = {
        columns: [],
        rows: [],
        chartSettings: {}
      };

      useBandCharts.columns = [watchDate, watchUseBand];

      data.map(item => {
        let { time, usage_idle } = item;
        // let value = isDcache ? diffBps : out_bps;
        let value = usage_idle;
        let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");

        let useBandRows = [];
        // 日期处理
        useBandRows[watchDate] = date_at;
        useBandRows[watchUseBand] = 1 - toFixed(value * 0.01);

        useBandCharts.rows.push(useBandRows);
      });

      this.cpuResult = useBandCharts;
    },
    dealMem(data) {
      if (!data.length) {
        return;
      }
      let watchDate = this.$t("watchDetail.watchDate");
      let watchUseBand = this.$t("memText");
      // 此处为了中英文对照，所以动态处理
      let useBandCharts = {
        columns: [],
        rows: []
      };

      useBandCharts.columns = [watchDate, watchUseBand];

      data.map(item => {
        let { time, used_percent } = item;
        // let value = isDcache ? diffBps : out_bps;
        let value = used_percent;
        let date_at = moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");

        let useBandRows = [];
        // 日期处理
        useBandRows[watchDate] = date_at;
        useBandRows[watchUseBand] = toFixed(value * 0.01);

        useBandCharts.rows.push(useBandRows);
      });

      this.memResult = useBandCharts;
    },
    // 节点磁盘IO
    dealDiskio(data) {
      if (!data) {
        return;
      }

      let diskioResult = [];

      for (let i in data) {
        let item = data[i][0];

        diskioResult.push({
          title: i,
          time: moment(new Date(item.time)).format("YYYY-MM-DD HH:mm:ss"),
          io_util: item.io_util ? toFixed(item.io_util) : item.io_util
        });
      }

      this.diskioResult = diskioResult;
    },
    // 磁盘使用&& 磁盘空间利用率（百分比）
    dealDisk(data) {
      if (!data) {
        return;
      }
      let diskResult = [], memUsedResult = [];

      for (let i in data) {
        let item = data[i][0];

        diskResult.push({
          title: `${i}`,
          time: moment(new Date(item.time)).format("YYYY-MM-DD HH:mm:ss"),
          used_percent: item.used_percent ? toFixed(item.used_percent) : item.used_percent
        });

        memUsedResult.push({
          title: `${i}`,
          time: moment(new Date(item.time)).format("YYYY-MM-DD HH:mm:ss"),
          used: item.used ? toFixed(BytesToG(item.used)) : item.used
        });
      }

      this.diskResult = diskResult;
      this.memUsedResult = memUsedResult;
    },
    search() {
      let { newServerBcode, selectDate, selectQueryType } = this;
      selectDate = selectDate ? moment(selectDate).startOf("day").valueOf() : moment().startOf("day").valueOf();
      this.getData({ bcode: newServerBcode, date: selectDate, type:selectQueryType });
    },
    getData(data) {
      this.flowResult = [];
      this.memResult = [];
      this.cpuResult = [];
      this.diskResult = [];
      this.diskioResult = [];
      this.isLoading = true;
      this.getNodeInfByBcode(data).then(res => {
        this.isLoading = false;
        let {
          cpuResult,
          memResult,
          diskResult,
          flowResult,
          diskioResult
        } = res;

        this.dealFlow(flowResult);
        this.dealCpu(cpuResult);
        this.dealMem(memResult);
        this.dealDisk(diskResult)
        this.dealDiskio(diskioResult);
      });
    }
  },
  created() {
    this.getStandardNodeHostNameAndBcode().then(res => {
      this.hostNameOptions = res.data;
      let server = res.data.find(item => {
        return item.serverHostname;
      });
      let date = moment().valueOf();
      this.getData({ bcode: server.serverBcode, date });
      this.newServerBcode = server.serverBcode;
    });
  }
};
</script>

<style lang="stylus">
.watch-real-data {
  // width: 80%;
  margin: 20px auto;
}
</style>
